import { render, staticRenderFns } from "./UserPopView.vue?vue&type=template&id=de310a72&"
import script from "./UserPopView.vue?vue&type=script&lang=js&"
export * from "./UserPopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports